import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import React, { useState } from 'react'
import { CustomObjectRow } from './CustomObjectRow'
import { CustomObjectMapping } from '../../../../../../../models/Account'
import { ObjectMappingsList } from '../shared/ObjectMappingsList'

interface CustomObjectsListProps {
  serviceId: IntegrationServiceId
}

export const CustomObjectsList: React.FC<CustomObjectsListProps> = ({ serviceId }) => {
  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)
  const { watch, setValue } = useFormContext<IntegrationSettings>()

  const customObjects = watch('mappings.customObjects') as CustomObjectMapping[] | undefined

  const [justAddedIndex, setJustAddedIndex] = useState<number | null>(null)

  const handleAddObject = () => {
    const newObject: CustomObjectMapping = { objectName: '', fields: [], referenceFields: [] }
    const updatedList = customObjects ? [...customObjects, newObject] : [newObject]
    setValue('mappings.customObjects', updatedList)
    setJustAddedIndex(updatedList.length - 1)
  }

  return (
    <ObjectMappingsList
      items={customObjects ?? []}
      isLoading={isAccountFetching}
      getKey={(obj, index) => obj.objectName || `blank-${index}`}
      renderRow={(_, index) => <CustomObjectRow serviceId={serviceId} index={index} defaultExpanded={index === justAddedIndex} />}
      onAddObject={handleAddObject}
      addButtonLabel='+ Add object'
    />
  )
}
